<template>
  <div id="popup" class="animated fadeIn">
    <div class="bg">
      <!-- <div class="close" @click="$emit('closePopup',false)">
        <i class="fas fa-times"></i>
      </div> -->
      <div class="content">
        <!-- <div class="close" @click="$emit('closePopup')">✘</div> -->
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Popup',
  components: {},
  props: {
    pophtml: {
      type: String,
    },
    btn: {
      type: Object,
      default() {
        return {
          Url: '',
          Name: '確認',
        };
      },
    },
  },
  data() {
    return {};
  },
  methods: {},
  computed: {},
  created() {},
  mounted() {},
  watch: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#popup {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 100vh;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
}

@media (max-width: 420px) {
  #popup {
    /* height: unset; */
    overflow-y: auto;
  }
}

#popup .loginContent p {
  color: #001139;
  margin-bottom: 0rem;
  font-size: 1.4rem;
}

#popup .bg {
  background-color: #fff;
  width: 950px;
  padding: 20px;
  /* min-height: 250px; */
  text-align: center;
  position: relative;
  max-height: 90%;
  overflow-y: auto;
}

/* 11/30 暫時加入 */
#popup .bg .content {
  padding: 55px 100px;
}
@media (max-width: 1440px) {
  #popup .bg .content {
    padding: 55px 100px;
  }
}
@media (max-width: 768px) {
  #popup .bg .content {
    padding: 55px 50px;
  }
}
@media (max-width: 420px) {
  #popup .bg .content {
    padding: 10px;
  }
}

#popup .bg .close {
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
  transition: 0.35s;
  background-color: #001139;
  padding: 10px;
  opacity: 1;
  color: #fff;
}
#popup .bg .close:hover {
  color: #ee8b59;
}
#popup .bg .content .close {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 18px;
  height: 18px;
  cursor: pointer;
}
#popup .bg .content h3 span.orange {
  font-size: 1.75rem;
  color: #f68e56;
}
#popup .bg .content >>> span {
  color: #c0272d;
  font-size: 1.2rem;
  padding: 20px 0;
  display: inline-block;
}
#popup .bg .content >>> p {
  line-height: 1.5;
  letter-spacing: 2px;
  padding: 10px 0;
}
#popup .bg .content >>> p a {
  color: #001139;
  text-decoration: underline;
}
#popup .bg .content >>> p span {
  color: #c0272d;
  padding: 0;
  font-size: 1rem;
}

#popup .bg .content >>> p span.orange {
  color: #f68e56;
}

/* #popup .bg .btn_box {
  width: 165px;
  margin: auto;
  padding: 15px 0;
} */
@media screen and (max-width: 767px) {
  #popup .bg {
    width: 95%;
    padding: 10px;
  }
  #popup .bg .content >>> span {
    padding: 10px 0;
  }
  #popup .bg .content h3 span.orange {
    font-size: 1.25rem;
    color: #f68e56;
  }
}
</style>
